module.exports = __webpack_public_path__ + "static/media/payments.4bb31e4e.png";